/* Presentation only. No tracking, consent changes, or automatic cart writes. */
(() => {
  const root = document.querySelector('[data-dpk-product-extras]');
  if (root) {
    let timer, revision = 0, controller;
    const refresh = () => {
      const run = ++revision;
      controller?.abort();
      // Old suggestions must not remain actionable after a cart change.
      root.hidden = true;
      clearTimeout(timer);
      timer = setTimeout(async () => {
        controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 8000);
        try {
          const url = new URL(location.href);
          url.searchParams.set('section_id', root.dataset.section);
          const response = await fetch(url, {credentials:'same-origin',cache:'no-store',signal:controller.signal});
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(),'text/html');
          const replacement = html.querySelector('[data-dpk-product-extras]');
          if (!replacement || run !== revision) return;
          root.innerHTML = replacement.innerHTML;
          root.hidden = replacement.hidden;
        } catch { /* Native purchase flow remains available. Stale extras stay hidden. */ }
        finally { clearTimeout(timeout); }
      }, 160);
    };
    const cart = document.getElementById('CartDrawer');
    if (cart) new MutationObserver(records => {
      if (records.some(r => r.target === cart || r.target.id === 'CartDrawer-CartItems' || r.target.classList?.contains('drawer__inner'))) refresh();
    }).observe(cart,{childList:true,subtree:true});
    window.addEventListener('pageshow', e => { if (e.persisted) refresh(); });
  }

  // Keep the rewards launcher out of consent dialogs. Its own popup remains user controlled.
  const updateJoy = () => {
    const button = document.getElementById('Avada-Joy_FloatingButtonTrigger');
    if (button && button.getAttribute('aria-label') !== 'Punkty i nagrody') button.setAttribute('aria-label','Punkty i nagrody');
    const cookieUi = [...document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs')]
      .some(node => node.getClientRects().length > 0 && getComputedStyle(node).visibility !== 'hidden');
    document.body.classList.toggle('dpk-cookie-ui-open',cookieUi);
  };
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {scheduled = false; updateJoy();});
  }).observe(document.body,{childList:true,subtree:true});
  updateJoy();
})();
